<script setup lang="ts">
import './assets/style.scss'
import { computed, ref } from 'vue'
import { useModel } from './../model/model.ts'
import { useRoute, useRouter } from 'vue-router'
import { useSendForm } from './../model/api.ts'

const route = useRoute()
const router = useRouter()
const { data, rules, loadData } = useModel()
const { sendForm, isPending } = useSendForm()

const tabId = computed(() => String(route.params.entity_id || ''))

const { isFetching } = loadData(tabId)

const valid = ref(false)

/**
 * Функция отправки данных
 */
const submitHandler = () => {
  sendForm(
    {
      ...data.value,
      sort: Number(data.value.sort),
    },
    valid.value,
  )
}

/**
 * Получаем ссылку на возврат к списку
 */
const backLink = computed(() => {
  return router.resolve({
    name: 'objects.groups.admin.config',
    params: {
      ...route.params,
      action: '',
      entity_id: '',
    },
  })
})
</script>

<template>
  <h2 class="mb-4 text_head">
    {{ $t('itf.tabs_config_edit') }}
  </h2>

  <VForm :disabled="isFetching" v-model="valid" @submit.prevent="submitHandler">
    <div class="form__grid_3">
      <VTextField :label="$t('itf.name')" v-model="data.name" :rules="rules.name" />

      <VTextField :label="$t('itf.alias')" v-model="data.alias" :rules="rules.alias" readonly />
    </div>

    <div class="form__grid_3">
      <VTextField :label="$t('itf.icon')" v-model="data.icon" :rules="rules.icon" />

      <VTextField
        type="number"
        :max="10000"
        :min="10"
        :label="$t('itf.sort')"
        v-model="data.sort"
      />
    </div>

    <div class="form__grid_3 mb-4">
      <div>
        <VCheckbox
          :label="$t('itf.is_interface_show')"
          class="ml-2"
          density="compact"
          v-model="data.is_show"
        />

        <VCheckbox
          :label="$t('itf.is_mobile_show')"
          class="ml-2"
          density="compact"
          v-model="data.is_mobile"
        />
      </div>
    </div>

    <div class="form__btn_left">
      <VBtn type="submit" :loading="isPending">{{ $t('itf.save') }}</VBtn>
      <VBtn :to="backLink" variant="tonal" color="default">{{ $t('itf.back') }}</VBtn>
    </div>
  </VForm>
</template>
